// import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    code: '',
    showSideBar: true,
    showCode: false,
    phoneMode: false,
    displayWidth: 0,

    language: 'en',
    imported: {
      en: false,
      ko: false
    },
    languageCallback: () => {},
    languagePopupData: {},

    userInfo: {},
    project: {},
    devices: {},
    myDevices: {},
    device: {},
    tabs: {},
    filteredTabs: [],
    isAdmin: false,
    isModified: false,
    isPublish: false,
    blocklyXml: '',
    loginData: {},
    userPopupData: {},
    passwordPopupData: {},
    leavePopupData: {},
    infoPopupData: {},
    emailVerificationPopupData: {},
    messagePopupData: {},
    confirmPopupData: {},
    openProjectPopupData: {},
    saveProjectPopupData: {},
    renameProjectPopupData: {},
    urlEditProjectPopupData: {},
    projectDetailPopupData: {},
    addDevicePopupData: {},
    helpPopupData: {}
  },
  mutations,
  actions
})

export default store
